import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoginResponse } from '../../../interface/interfaces';
import { USER_AND_TOKEN } from '../../../constants/constants';

interface IInitialState {
    userAndTokenData: ILoginResponse | null;
}

const storedUserAndTokenData = localStorage.getItem(USER_AND_TOKEN);
const initialUserAndTokenData: ILoginResponse | null = storedUserAndTokenData ? JSON.parse(storedUserAndTokenData) : null;

const initialState: IInitialState = {
    userAndTokenData: initialUserAndTokenData,
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        saveUserAndTokenData: (state: IInitialState, action: PayloadAction<ILoginResponse>) => {
            state.userAndTokenData = action.payload;
            localStorage.setItem(USER_AND_TOKEN, JSON.stringify(action.payload));
        },

        removeUserAndTokenData: (state: IInitialState) => {
            state.userAndTokenData = null;
            localStorage.removeItem(USER_AND_TOKEN);
        },
    },
});

export default loginSlice.reducer;
export const { saveUserAndTokenData, removeUserAndTokenData } = loginSlice.actions;
